import { createApp } from 'vue'
import App from './App'
import router from './router'
import helper from './helper'
import axios from 'axios'
import VueAxios from 'vue-axios'

const vuejs_app = createApp(App)

vuejs_app.use(router)
vuejs_app.use(VueAxios, axios)
vuejs_app.mixin( helper)

function VUEJSonCordovaDeviceReady() 
{
  document.getElementById('deviceready').classList.add('ready');

  vuejs_app.mount('#vuejs_app')
  if( window.cordova.platformId === 'ios')
  {
    document.body.classList.add('body_ios');
  }
  if( window.cordova.platformId === 'android')
  {
    document.body.classList.add('body_android');
  }
  document.body.classList.add(window.cordova.platformId);
}

if(window.cordova)
{
  document.body.classList.add('body_cordova');
  document.addEventListener('deviceready', VUEJSonCordovaDeviceReady, false);
} 
else 
{
  document.body.classList.add('body_not_cordova');
  vuejs_app.mount('#vuejs_app')
}


